import { EnumVerifyPayeeMatch } from 'src/api';

export const NOT_REQUIRED_TO_VOP = 'Not Required To Vop';

export const getVopType = (VopResponseType: EnumVerifyPayeeMatch | undefined, vopDetails: string | undefined) => {
  if (VopResponseType === EnumVerifyPayeeMatch.NOAP && vopDetails === NOT_REQUIRED_TO_VOP) {
    return EnumVerifyPayeeMatch.NOAP_OPT;
  }
  return VopResponseType;
};
